// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2f32fe52","977":"afcadefc"}[chunkId] + ".chunk.js";
};